export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          关于爆瓜
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10">
            <p className="text-foreground-700 leading-relaxed text-base mb-4">
              爆瓜网是全网领先的娱乐资讯聚合平台，致力于为广大瓜友提供最新、最快、最全的吃瓜爆料与明星八卦内容。
              我们以「吃瓜不迷路，爆料早知道」为使命，每日追踪娱乐圈最新动态，从顶流恋情到综艺名场面，
              从影视剧透到时尚穿搭，全方位覆盖你的吃瓜需求。
            </p>
            <p className="text-foreground-700 leading-relaxed text-base mb-6">
              平台汇聚了海量优质内容，由资深编辑团队全天候值守，确保每一条资讯都经过严格甄选。
              无论是突发爆料还是深度专题，爆瓜网始终站在吃瓜第一线，为你的每日茶余饭后增添谈资。
              收藏爆瓜网官网入口，吃瓜永远快人一步。
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-primary-500"></i>
                <span>内容严格审核</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-flashlight-line text-accent-500"></i>
                <span>24小时极速更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-user-heart-line text-secondary-500"></i>
                <span>百万瓜友信赖</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}